import React from 'react'

interface EmailSuggestionsProps {
  suggestions: string[]
  onSelect: (suggestion: string) => void
}

export const EmailSuggestions = ({ suggestions, onSelect }: EmailSuggestionsProps) => {
  if (suggestions.length === 0) return null

  return (
    <ul className="suggestions-box">
      {suggestions.map((suggestion, index) => (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        <li key={index} onClick={() => onSelect(suggestion)} className="suggestion-item">
          <span className="suggestion-text">{suggestion}</span>
        </li>
      ))}
    </ul>
  )
}
